


































































import Vue from 'vue'
import ProductCardFunction from '@/common/components/productCard/ProductCardFunction.vue'
import SizeDetail from '@/product/components/SizeDetail.vue'
import {
  ProductInfo,
  ProductSku,
  ProductState,
  ProductCardFunction as ProductCardFunctionType
} from '@/product/types'
import { TopPageIndustry } from '@/common/types'
import { topIndustries } from '@/top/data/industries'

enum TAB_TYPES {
  SPECS = 'specs',
  SIZE = 'size',
}

interface ListItem {
  label: string
  content: string
}

export default Vue.extend({
  components: {
    ProductCardFunction,
    SizeDetail
  },
  data(): {
    selectedTab: TAB_TYPES
  } {
    return {
      selectedTab: TAB_TYPES.SPECS
    }
  },
  computed: {
    TAB_TYPES(): typeof TAB_TYPES {
      return TAB_TYPES
    },
    detailTabs(): { displayName: string, type: TAB_TYPES }[] {
      return [
        {
          displayName: '商品説明・仕様',
          type: TAB_TYPES.SPECS
        },
        {
          displayName: 'サイズ',
          type: TAB_TYPES.SIZE
        }
      ]
    },
    storeState(): ProductState {
      return this.$store.state
    },
    product(): ProductInfo {
      return this.storeState.productDetail.product
    },
    sku(): ProductSku {
      return this.storeState.productDetail.sku
    },
    productDescriptions(): string {
      return this.product.description || ''
    },
    productCardFunctions(): Readonly<ProductCardFunctionType[]> {
      return this.product.productCardItems
    },
    genderName(): string {
      return this.product.gender.split('=')[1] || ''
    },
    industries(): TopPageIndustry[] {
      return topIndustries
    },
    industryName(): string {
      if (this.product.industry.industryName === 'casual') {
        return this.industries.find(
          industry => industry.industryName === 'office'
        )?.displayName || ''
      }
      return this.industries.find(
        industry => industry.industryName === this.product.industry.industryName
      )?.displayName || ''
    },
    brandUrl(): string {
      return `/brands/${this.product.brandName}`
    },
    categoryByBrandUrl(): string {
      return `${this.product.category.url}?f_brand=${this.product.brandName}`
    },
    industryUrl(): string {
      return this.product.industry.industryName === 'office'
        ? '/industries/casual'
        : `/industries/${this.product.industry.industryName}`
    },
    listItems(): ListItem[] {
      const result  = []
      if (this.sku.materialName)
        result.push({ label: '生地素材', content: this.sku.materialName })
      if (this.sku.composition)
        result.push({ label: '混用率', content: this.sku.composition })
      result.push({
        label: '性別',
        content: this.genderName
      })
      result.push({
        label: 'その他',
        content:
          '・サイズはメーカーの基準によります。機能に関する内容はラクスルがその商品に関して得ている情報を元に記載しております。\n・商品を洗濯する際は、実際の商品に付いているタグを必ずご確認の上、タグの表示に基づいて対応ください。\n・商品は予告なしにメーカー欠品または廃盤になる可能性がございます。予めご了承くださいますようお願い申し上げます。'
      })
      return result
    }
  },
  methods: {
    setSelectedTab(tab: TAB_TYPES) {
      this.selectedTab = tab
    },
    isTabSelected(tab: TAB_TYPES): boolean {
      return this.selectedTab === tab
    }
  }
})
